/**
 * product.ads-images — proxies COD intercalados → click real #rsi_buy_now_button.
 * Feedback: loading al boot (Releasit) + opening al click (formulario).
 */
(function () {
  if (window.__menvoraAdsImagesCod) return;
  window.__menvoraAdsImagesCod = true;

  var ROOT = '[data-menvora-ads-images]';
  var PROXY = '[data-menvora-cod-proxy]';
  var READY_POLL_MS = 200;
  var READY_TIMEOUT_MS = 12000;
  var OPENING_TIMEOUT_MS = 10000;
  var LABEL_LOADING = 'Cargando…';
  var LABEL_OPENING = 'Abriendo…';

  var gateReady = false;
  var openingBtn = null;
  var openingTimer = null;

  function rsiReady() {
    if (document.body.classList.contains('is-rsi-ready')) return true;
    return !!document.getElementById('rsi_buy_now_button');
  }

  function prefersReducedMotion() {
    try {
      return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
    } catch (e) {
      return false;
    }
  }

  function findCodButton() {
    return (
      document.getElementById('rsi_buy_now_button') ||
      document.querySelector('[data-rsi-cod-button="true"]')
    );
  }

  function proxyLabel(btn) {
    return btn.querySelector('[data-proxy-label]');
  }

  function readyLabel(btn) {
    return btn.getAttribute('data-label-ready') || 'Pagar contra entrega';
  }

  function setProxyVisual(btn, state) {
    // state: loading | ready | opening
    var label = proxyLabel(btn);
    btn.classList.toggle('is-loading', state === 'loading');
    btn.classList.toggle('is-opening', state === 'opening');
    btn.disabled = state !== 'ready';
    btn.setAttribute('aria-busy', state === 'ready' ? 'false' : 'true');
    if (label) {
      if (state === 'loading') label.textContent = LABEL_LOADING;
      else if (state === 'opening') label.textContent = LABEL_OPENING;
      else label.textContent = readyLabel(btn);
    }
  }

  function setAllProxies(state) {
    document.querySelectorAll(PROXY).forEach(function (btn) {
      if (state === 'ready' && openingBtn && btn === openingBtn) return;
      setProxyVisual(btn, state);
    });
  }

  function clearOpening(reason) {
    if (openingTimer) {
      window.clearTimeout(openingTimer);
      openingTimer = null;
    }
    var btn = openingBtn;
    openingBtn = null;
    if (btn && gateReady) setProxyVisual(btn, 'ready');
    else if (btn) setProxyVisual(btn, 'loading');
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function' && reason) {
      window.MenvoraAnalytics.track('CodCtaProxyOpeningEnd', {
        reason: String(reason).slice(0, 40),
        template: 'ads-images',
      });
    }
  }

  function beginOpening(btn) {
    if (openingBtn) clearOpening('supersede');
    openingBtn = btn;
    setProxyVisual(btn, 'opening');
    // Bloquear otros proxies mientras abre
    document.querySelectorAll(PROXY).forEach(function (other) {
      if (other !== btn) {
        other.disabled = true;
        other.setAttribute('aria-busy', 'true');
      }
    });
    openingTimer = window.setTimeout(function () {
      clearOpening('timeout');
      if (gateReady) setAllProxies('ready');
    }, OPENING_TIMEOUT_MS);
  }

  function openCod(source, proxyBtn) {
    var btn = findCodButton();
    if (!btn) return false;
    if (proxyBtn) beginOpening(proxyBtn);
    try {
      btn.click();
    } catch (e) {
      clearOpening('click-error');
      if (gateReady) setAllProxies('ready');
      return false;
    }
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function') {
      window.MenvoraAnalytics.track('CodCtaProxyClick', {
        source: String(source || 'proxy').slice(0, 40),
        template: 'ads-images',
      });
    }
    return true;
  }

  function onProxyClick(e) {
    var btn = e.target.closest(PROXY);
    if (!btn || btn.disabled) return;
    e.preventDefault();
    if (!gateReady) return;
    openCod(btn.getAttribute('data-menvora-cod-proxy') || 'between', btn);
  }

  var INTERACTIVE =
    'a,button,input,select,textarea,label,[role="button"],[role="link"],[role="radio"],[data-menvora-variant-picker],.product--ads-images__variants';
  function onBandClick(e) {
    if (e.target.closest(INTERACTIVE)) return;
    var band = e.target.closest('[data-after-image]');
    if (!band) return;
    if (!gateReady) return;
    var afterImg = band.getAttribute('data-after-image');
    if (afterImg === '1') {
      openCod('band-tap-atf', null);
    } else {
      var proxy = band.querySelector(PROXY);
      if (proxy && !proxy.disabled) proxy.click();
    }
  }

  function onFormOpenChange() {
    if (document.body.classList.contains('menvora-cod-form-open')) {
      clearOpening('form-open');
      // Mantener proxies disabled mientras el form está abierto (CSS/chrome guard)
      document.querySelectorAll(PROXY).forEach(function (btn) {
        btn.disabled = true;
      });
    } else if (gateReady) {
      setAllProxies('ready');
    }
  }

  /** Toalla: tap hero → scroll a packs/ofertas (data-menvora-pack-stage). */
  function scrollToOffers(e) {
    var hit = e.target && e.target.closest && e.target.closest('[data-menvora-scroll-to-offers]');
    if (!hit) return;
    e.preventDefault();
    var stage =
      document.querySelector('[data-menvora-pack-stage]') ||
      document.querySelector('[data-menvora-ads-images] .product-form__buttons');
    if (!stage) return;
    stage.scrollIntoView({
      behavior: prefersReducedMotion() ? 'auto' : 'smooth',
      block: 'start',
    });
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function') {
      window.MenvoraAnalytics.track('HeroScrollToOffers', { template: 'ads-images' });
    }
  }

  function popQtyBadges() {
    document.querySelectorAll('.rsi-product-item-image .rsi-product-item-quantity').forEach(function (el) {
      el.classList.remove('menvora-qty-pop');
      void el.offsetWidth; // reflow para reiniciar animación
      el.classList.add('menvora-qty-pop');
    });
  }

  function watchQtyBadges() {
    var containers = document.querySelectorAll('.rsi-product-item-image');
    if (!containers.length) return;
    var obs = new MutationObserver(function () { popQtyBadges(); });
    containers.forEach(function (el) {
      obs.observe(el, { childList: true, subtree: true, characterData: true });
    });
    // También escuchar clics en los pack cards de Releasit
    document.addEventListener('click', function (e) {
      if (e.target.closest('.rsi-quantity-product, [class*="rsi-quantity-product"]')) {
        window.setTimeout(popQtyBadges, 80);
      }
    });
  }

  function markGateReady(reason) {
    if (gateReady) return;
    gateReady = true;
    if (!openingBtn) setAllProxies('ready');
    // Activar re-shake en cambio de pack
    window.setTimeout(watchQtyBadges, 400);
    if (window.MenvoraAnalytics && typeof window.MenvoraAnalytics.track === 'function') {
      window.MenvoraAnalytics.track('CodCtaProxyGateReady', {
        reason: String(reason || 'ready').slice(0, 40),
        template: 'ads-images',
      });
    }
  }

  function boot() {
    var root = document.querySelector(ROOT);
    if (!root) return;

    setAllProxies('loading');
    root.addEventListener('click', onProxyClick);
    root.addEventListener('click', onBandClick);
    root.addEventListener('click', scrollToOffers);

    // Si el botón RSI ya existe en DOM al arrancar (Releasit rápido o remount),
    // hacer gate inmediatamente sin esperar el primer tick del intervalo.
    if (rsiReady()) {
      markGateReady('boot-immediate');
    }

    var started = Date.now();
    var timer = window.setInterval(function () {
      if (rsiReady()) {
        window.clearInterval(timer);
        markGateReady('poll');
      } else if (Date.now() - started > READY_TIMEOUT_MS) {
        window.clearInterval(timer);
        markGateReady('timeout-fallback');
      }
    }, READY_POLL_MS);

    window.addEventListener('menvora:cod-cta-ready', function () {
      markGateReady('event');
    });

    // Form open/close (menvora-cod-funnel toggles body class)
    var mo = new MutationObserver(function (mutations) {
      for (var i = 0; i < mutations.length; i++) {
        if (mutations[i].attributeName === 'class') {
          onFormOpenChange();
          break;
        }
      }
    });
    mo.observe(document.body, { attributes: true, attributeFilter: ['class'] });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  /* ── Variant color picker (ads-images) — no abre COD ───────────────────── */
  var SWATCH_HEX = {
    rosa: '#f6b1af',
    azul: '#4cc6bf',
  };

  function hexLuma(hex) {
    var h = String(hex || '').replace('#', '');
    if (h.length === 3) h = h[0] + h[0] + h[1] + h[1] + h[2] + h[2];
    if (h.length !== 6) return 0;
    var r = parseInt(h.slice(0, 2), 16);
    var g = parseInt(h.slice(2, 4), 16);
    var b = parseInt(h.slice(4, 6), 16);
    return (0.299 * r + 0.587 * g + 0.114 * b) / 255;
  }

  function applyCodColor(hex) {
    if (!hex) return;
    var root = document.querySelector(ROOT) || document.documentElement;
    root.style.setProperty('--menvora-cod', hex);
    root.style.setProperty('--menvora-cta', hex);
    root.style.setProperty('--menvora-trust', hex);
    /* Mismo tint que .variant-pill.is-selected (42% swatch + blanco) → ink oscura */
    var ink = '#1a1a1a';
    root.style.setProperty('--menvora-cod-ink', ink);
    /* No forzar hex sólido: CSS usa color-mix igual que el badge seleccionado */
    document.querySelectorAll('#rsi_buy_now_button, [data-menvora-cod-proxy]').forEach(function (el) {
      el.style.removeProperty('background');
      el.style.removeProperty('background-color');
      el.style.removeProperty('border-color');
      el.style.removeProperty('border');
      el.style.setProperty('color', ink, 'important');
    });
  }

  function findVariant(variants, optionIndex, value) {
    return variants.find(function (v) {
      var opts = v.options || [];
      return String(opts[optionIndex]) === String(value);
    });
  }

  function formatMoney(cents, moneyFormat) {
    var amount = (Number(cents) / 100).toFixed(2);
    var fmt = moneyFormat || '${{amount}}';
    if (fmt.indexOf('{{amount_no_decimals}}') !== -1) {
      return fmt.replace('{{amount_no_decimals}}', String(Math.round(Number(cents) / 100)));
    }
    var withSep = amount.replace(/\B(?=(\d{3})+(?!\d))/g, ',');
    return fmt
      .replace('{{amount_with_comma_separator}}', amount.replace('.', ','))
      .replace('{{amount}}', withSep);
  }

  function syncVariantPrice(match, root) {
    if (!match || !root) return;
    var priceEl = root.querySelector('[data-menvora-variant-price]');
    if (!priceEl) return;
    var picker = root.querySelector('[data-menvora-variant-picker]');
    var moneyFormat = (picker && picker.getAttribute('data-money-format')) || '${{amount}}';
    var priceHtml = formatMoney(match.price, moneyFormat);
    var compare = match.compare_at_price;
    if (compare && Number(compare) > Number(match.price)) {
      priceHtml +=
        ' <s class="product--ads-images__product-compare" data-menvora-variant-compare">' +
        formatMoney(compare, moneyFormat) +
        '</s>';
    }
    priceEl.innerHTML = priceHtml;
  }

  function initVariantPicker(picker) {
    var formId = picker.getAttribute('data-product-form');
    var form = formId ? document.getElementById(formId) : null;
    var idInput = form ? form.querySelector('input[name="id"]') : null;
    var root = picker.closest(ROOT) || document;
    var jsonEl = picker.querySelector('[data-menvora-variant-json]');
    var variants = [];
    try {
      variants = JSON.parse(jsonEl && jsonEl.textContent ? jsonEl.textContent : '[]');
    } catch (e) {
      variants = [];
    }
    var selectedLabel = picker.querySelector('[data-menvora-variant-selected]');

    function selectBtn(btn) {
      if (!btn) return;
      var value = btn.getAttribute('data-menvora-variant-value');
      var optIdx = parseInt(btn.getAttribute('data-menvora-variant-option') || '0', 10);
      var swatch = (btn.getAttribute('data-swatch') || value || '').toLowerCase().trim();
      var hex =
        btn.style.getPropertyValue('--swatch').trim() ||
        SWATCH_HEX[swatch] ||
        '';

      picker.querySelectorAll('.product--ads-images__variant-pill').forEach(function (b) {
        var on = b === btn;
        b.classList.toggle('is-selected', on);
        b.setAttribute('aria-pressed', on ? 'true' : 'false');
      });
      if (selectedLabel) selectedLabel.textContent = value;

      var match = findVariant(variants, optIdx, value);
      if (match && idInput) {
        idInput.value = String(match.id);
        idInput.dispatchEvent(new Event('change', { bubbles: true }));
      }
      syncVariantPrice(match, root);
      applyCodColor(hex);
    }

    picker.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var btn = e.target.closest('.product--ads-images__variant-pill');
      if (!btn || !picker.contains(btn)) return;
      selectBtn(btn);
    });

    // seed from current selection
    var selected = picker.querySelector('.product--ads-images__variant-pill.is-selected');
    if (selected) selectBtn(selected);
  }

  function bootVariants() {
    document.querySelectorAll('[data-menvora-variant-picker]').forEach(initVariantPicker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootVariants);
  } else {
    bootVariants();
  }

  // Releasit may inject CTA late — re-apply color
  var codColorWatch = setInterval(function () {
    var picker = document.querySelector('[data-menvora-variant-picker] .is-selected');
    if (!picker) return;
    if (document.getElementById('rsi_buy_now_button')) {
      var sw = (picker.getAttribute('data-swatch') || '').toLowerCase();
      var hex = picker.style.getPropertyValue('--swatch').trim() || SWATCH_HEX[sw];
      if (hex) applyCodColor(hex);
      window.clearInterval(codColorWatch);
    }
  }, 400);
  setTimeout(function () {
    window.clearInterval(codColorWatch);
  }, 15000);
})();
